<div class="mt-40">
  <ecp-breadcrumb></ecp-breadcrumb>
  <div class="container mt-30">
    <div class="row is-flex">
      <ecp-cart-header></ecp-cart-header>
      <ng-container *ngIf="(framesCart$ | async).length === 0; else framesCart">
        <div class="col s12 m8" *ngIf="user$ | async">
          <div class="container">
            "My Favorites" is empty, please go back to the <a routerLink="/{{ patientId }}">catalog</a>.
          </div>
        </div>
      </ng-container>
      <ng-template #framesCart>
        <div class="col s12 m8 l8">
          <div class="container">
            <ecp-cart-details></ecp-cart-details>
          </div>
        </div>

        <div class="col s12 m4 l4">
          <div>
            <ecp-my-cart></ecp-my-cart>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
